import React, { useState, useEffect } from 'react';
import ReactGA from 'react-ga4';
import GuidedCalculator from './components/GuidedCalculator';
import './App.css';

function App() {
  const [selectedUnits, setSelectedUnits] = useState([]);
  const [result, setResult] = useState(null);
  const [expandStates, setExpandStates] = useState({
    pure: false,
    further: false,
    applied: false
  });

  // Track page view when component mounts
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
    
    // Track session-level referrer information
    const referrer = document.referrer;
    if (referrer) {
      ReactGA.event({
        category: 'Session',
        action: 'Session Start with Referrer',
        label: referrer,
        custom_parameters: {
          referrer_domain: new URL(referrer).hostname,
          session_type: window.self !== window.top ? 'iframe' : 'direct'
        }
      });
    }
  }, []);

  const resetApp = () => {
    // Track reset event
    ReactGA.event({
      category: 'User',
      action: 'Reset Calculator',
    });
    
    setSelectedUnits([]);
    setResult(null);
    setExpandStates({
      pure: false,
      further: false,
      applied: false
    });
  };

  // Function to handle unit selection with tracking
  const handleUnitSelection = (units) => {
    ReactGA.event({
      category: 'Calculator',
      action: 'Select Units',
      label: JSON.stringify(units)
    });
    setSelectedUnits(units);
  };

  return (
    <div className="App">
      <GuidedCalculator />
    </div>
  );
}

export default App; 